<template>
        <div class="container-principal">
        <PToast />
        <div class="container-card">
            <g-card
                :temCabecalho="false"
                altura="55vh"
                largura="80vw"
                minAltura="380px"
                class="larguraCard"
                paddingDefault="0px"

            >
                <div class="duasimagems">
                    <div class="container-login">
                        <div class="logo">
                            <div class="container-logo">
                                <img class="logo-login" src="@/assets/imgs/grupo_jauense_logo.svg">
                            </div>
                        </div>
                        <div class="form">
                            <span class="titulo-filtros-cabecalho">
                                Redefinir Senha
                            </span>
                            <span class="input-container2 p-input-icon-right">

                                <span class="input-container-senha p-input-icon-left">
                                    <i class="pi pi-lock icone-login" />

                                    <PInputText placeholder="Nova senha" class="borda" id="senha-login"  v-model="dataNewPassWord.newPassword" :type="tipo"></PInputText>
                                    <i v-on:click="mostrarSenha" class="pi pi-eye olho "></i>
                                </span>
                            </span>
                            <span class="input-container2 p-input-icon-right">
                                <span class="input-container-senha p-input-icon-left">
                                    <i class="pi pi-lock icone-login" />
                                    <PInputText
                                    @keyup.enter="salvarSenha"
                                     placeholder="Confirme a nova senha" 
                                     class="borda" id="senha-login"
                                      v-model="dataNewPassWord.confirmanewPassword" 
                                      :type="tipoConfirma">
                                    </PInputText>
                                    <i v-on:click="mostrarSenhaConfirma" class="pi pi-eye olho "></i>
                                </span>
                            </span>
                        </div>
                        <div class="botoes">
                            <PButton
                                v-on:click="salvarSenha"
                                :label="labelBotao"
                                class="p-button-rounded"
                                :style="`width: ${tamanhoBotao}`"
                            >
                                <div v-if="estaCarregando" class="container-spinner">
                                    <i class="pi pi-spin pi-spinner"></i>
                                </div>
                            </PButton>
                        </div>
                    </div>
                </div>
            </g-card>
        </div>
    </div>
</template>
<script>
import ForgotPassword from './ForgotPassword.js'
export default ForgotPassword
</script>

<style scoped>@keyframes fadeIn {
    0%{
        transform: scale(0);
        opacity: 0;
    }
    100% {
        transform: scale(1);
        opacity: 1;
    }
}

.outraimagem{
    display: none;
}
.olho{  
    margin-left: 94%;
    color: #6c757d;
}
.borda{
  border: none;
}

.input-container-senha{
    width: 100%;
    display: flex;
    border: 1px solid #ced4da;
    border-radius: 25px;
}
.input-container-senha:hover{
    border: 1px solid #4f2c19 !important;
}
.container-principal {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: url(@/assets/imgs/fundo_retangulos.svg);
    background-size: 100%;
    background-position: center;
}

.container-card{
    animation: fadeIn 1s;
}

.p-input-icon-right > i:last-of-type {
    right: -0.5rem;
    color: #6c757d;
}

.container-login {
    height: 100%;
    min-height: 380px;
    align-items: center;
    gap: 5px;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 38% 23% 39%;
    grid-auto-flow: row;
    grid-template-areas:
        "logo"
        "form"
        "botoes";
}

.icone-login{
    margin-left: 5px;
}

.input-container{
    width: 80%;
}

.input-container2{
    width: 80%;
}


.p-inputtext {
    border-radius: 25px;
    width: 100%;
}

.p-button{
    transition: .9s;
    background-color: #fcb316;
    color: #4f2c19;
    border: none;
    font-weight: bold;
    box-shadow: 0px 4px 5px 1px rgba(0, 0, 0, 0.2);
}

.p-button:hover{
    background-color: #d19514 !important;
    color: #4f2c19 !important;
}

.esqueci-senha{
    color: #4f2c19;
    text-decoration: underline;
    cursor: pointer;
}

.logo { grid-area: logo; }

.form {
    display: flex;
    flex-direction: column;
    gap: 20px;
    justify-content: center;
    align-items: center;
    grid-area: form;
}

.botoes {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
    grid-area: botoes;
}

.container-spinner{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    color: #9a7b43;
}



@media (min-width:310px) {
    .olho{  
        margin-left: 87%;
    }

}

@media (min-width:368px) {
    .olho{  
        margin-left: 90%;
    }
}

@media (min-width:461px) {
.container-principal{
        background: url(@/assets/imgs/Fundo_login_1.svg) no-repeat top left,
        url(@/assets/imgs/Fundo_login_2.svg) no-repeat bottom right;

            background-size: 100%;
    background-position: center;

    }
    .olho{  
        margin-left: 91%;
    }
}

@media (min-width:600px) {
        .container-principal{
        background: url(@/assets/imgs/Fundo_login_1.svg) no-repeat top left,
        url(@/assets/imgs/Fundo_login_2.svg) no-repeat bottom right;

            background-size: 100%;
    background-position: center;

    }
    .olho{  
        margin-left: 94%;
    }

}

@media (min-width:801px) {
}

@media (min-width:900px) {
    .olho{  
        margin-left: 96%;
    }
}

@media (min-width:1025px) {
    .duasimagems{
    display: flex;
    justify-content: space-around;
}
    .outraimagem{
        display: inline;
    }

    .p-input-icon-right > i:last-of-type {
        right: -0.5rem;
        color: #6c757d;
    }

    .imagemdois{
        width: 100%;
        opacity: 0.6;
        margin-left: 10px;
        margin-top: -10px;
    }

    .container-login{
        width: 50%
    }

    .container-principal{
        background: url(@/assets/imgs/Fundo_login_1.svg) no-repeat top left,
        url(@/assets/imgs/Fundo_login_2.svg) no-repeat bottom right;

            background-size: 100%;
    background-position: center;

    }
    .olho{  
        margin-left: 90%;
    }

}

@media (min-width:1281px) {
    .olho{  
        margin-left: 92%;
    }
}

@media (min-width:1500px) {
    .container-login {
    height: 100%;
    min-height: 380px;
    align-items: center;
    margin-top: 46px;
    gap: 5px;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 38% 23% 39%;
    grid-auto-flow: row;
    grid-template-areas:
        "logo"
        "form"
        "botoes";
}
.larguraCard{
    width: 65vw;
}
.duasimagems{
    display: flex;
    justify-content: space-around;
}
    .imagemdois{
        width: 100%;
        opacity: 0.6;
        margin-left: 14px;
        margin-top: -10px;
    }
    .olho{  
        margin-left: 93%;
    }
}
</style>